module.exports = __webpack_public_path__ + "img/icon-cs.c142557b.svg";